import * as React from 'react';
import { format } from '@websky/core/src/utils';
const DatepickerValue = ({ dateTo, dateBack, isOpen }) => {
    return React.createElement(React.Fragment, null, format(dateTo, 'eeeeee'));
};
export default DatepickerValue;
